import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { AppInfo } from '../../models/app-info';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AppWhiteLabelService } from '../../services/app-info-service';
import { PagingService } from '../../../../shared/Services/PagingService';
import { AddAppInfoComponent } from '../add-app-info/add-app-info.component';
import { ConfirmationDialogComponent } from '../../../../shared/Components/confirmation-dialog.component';

@Component({
  selector: 'app-get-app-info',
  templateUrl: './get-app-info.component.html',
  styleUrls: ['./get-app-info.component.scss']
})
export class GetAppInfoComponent extends BaseComponent implements OnInit {
  appInfo: AppInfo;
  form: FormGroup;

  constructor(
    service: AppWhiteLabelService,
    route: Router,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private fb: FormBuilder,
    private paging: PagingService
  ) {
    super(route, service, null);
  }

  ngOnInit() {
    this.loadEntities();
  }

  setPage(page: number) {
    this.finishLoading = false;
    this.paging.setPage(page, this.pagingModel, this.service);
    this.finishLoading = true;
  }

  //   typeSelected(data){
  // console.log(data)
  // debugger

  //   }

  detail(id: number) {
    const route = ['admin/services-detail/' + id];
    this.route.navigate(route);
  }
  addNew() {
    this.diag.open(AddAppInfoComponent).onClose.subscribe((res) => {
      console.log(res);
      if (res === 'true') {
        this.loadEntities();
      }
    });
  }
  update(model) {
    const copymodel = {...model}
    this.diag.open(AddAppInfoComponent, { context: { id: model.id, model: copymodel, isEdit: true } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.loadEntities();
      }
    });
  }
  delete(id) {
    this.diag
      .open(ConfirmationDialogComponent, {
        context: { message: 'Are you sure you want to delete this item?' } as Partial<ConfirmationDialogComponent>,
      })
      .onClose.subscribe((result) => {
        if (result) {
          this.service.delete(id).subscribe(() => {
            this.toast.show('تم حذف الخدمة بنجاح', '', { status: 'success', duration: 3000 });
            this.loadEntities();
          });
        }
      });
  }
}
